namespace advisorop.components.advisor {
    
    class HouseholdFormController {
        $router;
        household: domains.IHousehold;        

        static $inject = ["advisorService"];
        constructor(private advisorService: services.AdvisorService) {

        }

        householdSaved(household: domains.IHousehold): void {
            toastr.success("Household has been successfully saved.");
            this.household = household;            
            //this.$router.navigate(["Dashboard"]);
        };

        loadHousehold(householdId: number): void {
            this.advisorService.getHousehold(householdId)
                .success((data) => {
                    this.household = data;
                })
                .error((data, status) => {
                    toastr.error("Error " + status + " " + data);
                });
        };
        
        $onInit(): void {
        }

        $routerOnActivate(next, previous) {
            if (next.params.householdId) {
                this.loadHousehold(<number>next.params.householdId);
            }
        }
    }


    class HouseholdForm implements ng.IComponentOptions {
        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;
        public $routeConfig: any;
        $canActivate;

        constructor() {
            this.controller = HouseholdFormController;
            this.controllerAs = "vm";
            this.bindings = {
                $router: "<"
            };
            this.templateUrl = "spa/advisor-module/views/household-form.html";
            this.$canActivate = ["advisorService", (advisorService: services.AdvisorService) => {
                if (advisorService.isAdminModeEnabled()) {
                    toastr.info("Please exit from Admin Mode to enable creating/editing household");
                    return false;
                }
                return true;
            }];
        }

    }
    angular.module(Constants.APP).component("householdForm", new HouseholdForm());


}